import React from "react";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import { GoldButton } from "../components/ui-kit";

const NotFound = () => (
  <>
    <Seo title="Page Not Found | Build Highland Homes" description="The page you are looking for could not be found." path="/404" />
    <section className="min-h-screen flex items-center justify-center text-center px-6">
      <div>
        <p className="font-serif-display text-7xl gold-gradient-text mb-4">404</p>
        <h1 className="font-serif-display text-3xl text-[#f3ede0] mb-4">Page Not Found</h1>
        <p className="text-[#a39d90] mb-8 max-w-md mx-auto">The page you're looking for doesn't exist. Let's get you back to building your custom home.</p>
        <GoldButton to="/">Back to Home</GoldButton>
      </div>
    </section>
  </>
);

export default NotFound;
